import type { UseQueryResult } from '@tanstack/react-query'
import type { AxiosError } from 'axios'
import type { WebhookLogsResponse, WebhookLogsFilters } from './types'

import { useQuery } from '@tanstack/react-query'

import $api from '../../API'

export function useWebhookLogs(
  filters: WebhookLogsFilters
): UseQueryResult<WebhookLogsResponse, AxiosError> {
  return useQuery<WebhookLogsResponse, AxiosError>({
    queryKey: ['webhook-logs', filters],
    async queryFn({ signal }) {
      const params = new URLSearchParams()

      if (filters.page !== undefined) {
        params.append('page', filters.page.toString())
      }
      if (filters['page-size']) {
        params.append('page-size', filters['page-size'].toString())
      }

      if (filters['date-from']) {
        params.append('date-from', filters['date-from'])
      }
      if (filters['date-to']) {
        params.append('date-to', filters['date-to'])
      }

      if (filters.entity?.length) {
        filters.entity.forEach(entity => params.append('entity', entity))
      }

      if (filters.search) {
        params.append('search', filters.search)
      }

      if (filters['response-status']?.length) {
        filters['response-status'].forEach(status =>
          params.append('response-status', status.toString())
        )
      }

      if (filters['token-valid']?.length) {
        filters['token-valid'].forEach(tokenValid =>
          params.append('token-valid', tokenValid.toString())
        )
      }

      if (filters['is-on-hold']?.length) {
        filters['is-on-hold'].forEach(isOnHold => params.append('is-on-hold', isOnHold.toString()))
      }

      const queryString = params.toString()
      const url = `/webhook-logs${queryString ? `?${queryString}` : ''}`

      const response = await $api.get<WebhookLogsResponse>(url, { signal })
      return response.data
    }
  })
}
